import { useState } from 'react';
import { axiosInstance } from '../../../config/axiosConfig';
import Button from '../Button';
import { useTranslation } from 'react-i18next';
import { downloadFile } from '../../../utils/downloadExcelSheet';

export default function ExportExcel({
  endpoint,
  fileName,
  data,
  filters,
  post,
  mimeType,
  children,
  customClass,
  downloadFileCustomFun
}: {
  endpoint: string;
  data?: any;
  fileName: string;
  filters?: any;
  post?: boolean;
  mimeType?: string; // e.g., 'application/pdf' for PDF
  children?: any;
  customClass?: string;
  downloadFileCustomFun?: (data: Blob, fileName: string) => void;
}) {
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();

  async function exportReport() {
    setLoading(true);
    let link = endpoint;

    // Append filters as query params to the API link
    const searchParams = new URLSearchParams();
    if (filters && typeof filters === 'object') {
      Object.entries(filters).forEach(([key, value]) => {
        if (value === undefined || value === null || value === '') return;
        if (Array.isArray(value)) {
          value.forEach((v) => searchParams.append(key, String(v)));
        } else {
          searchParams.set(key, String(value));
        }
      });
    }
    const hasExistingQuery = endpoint.includes('?');
    const paramsString = searchParams.toString();
    link = paramsString ? `${endpoint}${hasExistingQuery ? '&' : '?'}${paramsString}` : endpoint;

    const response = await (post
      ? axiosInstance.post(link, data ?? {}, { responseType: 'blob' })
      : axiosInstance.get(link, { responseType: 'blob' }));

    const detectedMime = mimeType || (typeof filters?.export_type === 'string' && filters.export_type.toLowerCase() === 'pdf' ? 'application/pdf' : undefined);
    downloadFileCustomFun ? downloadFileCustomFun(response.data, fileName) : downloadFile(response.data, fileName, detectedMime);
    setLoading(false);
  }

  return <Button customClass={customClass || ''} onClick={exportReport} loading={loading} type="button" text={children || t('export_excel')} />;
}
